export class ExceptionErrorDto {

  public code!: string;
  public message: string | undefined;
  public additionalMessage: string | undefined;
  public exceptionClass: string | undefined;

  constructor(init?: Partial<ExceptionErrorDto>) {
    Object.assign(this, init);
  }

  public static of(code: string, message?: string, exceptionClass?: string): ExceptionErrorDto {
    return new ExceptionErrorDto({code, message, exceptionClass});
  }
}
